<template>
    <div class="blank contacts-manage">
        <div class="general-section" style="border-top-left-radius: 0px !important;">
            <div class="d-flex align-items-center justify-content-center" style="height: 400px;"
                v-if="(ajaxCallinprogress || list_loader) && !is_ticket_details_not_found">
                <!-- <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" /> -->
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
            </div>
            <div v-else-if="!ajaxCallinprogress && is_ticket_not_found">
                <h1 class="fs-14 text-danger text-center py-3">
                    <div class="fw-500">No Ticket details found...</div>
                    <img src="/static/images/new-theme2024/not_found.svg" />
                </h1>
            </div>
            <div v-else class="">
                <div class="mb-3">
                    <div class="header-detail-view-new mt-5 px-3 py-2">
                        <div>
                            <span class=" pl-1">Ticket #{{general_details.ticket_number}}</span>
                        </div>
                        <div class="d-flex">
                            <div class="mr-2">
                                <el-popover
                                    placement="bottom"
                                    trigger="click">
                                    <div class="fs-14 fw-500">
                                        <div  class="align-items-center text-center">
                                            <span class="header-text">Eisenhower Matrix</span>
                                        </div>
                                        <div class="d-flex align-items-center mt-3">
                                            <div class="quadrant top-left" :class=" priority_of_ticket.hasOwnProperty('imp_not_urgent') && priority_of_ticket.imp_not_urgent ? 'active-matrix' : '' ">
                                                Important <br>- Not Urgent
                                            </div>
                                            <div class="quadrant top-right" :class=" priority_of_ticket.hasOwnProperty('imp_urgent') && priority_of_ticket.imp_urgent ? 'active-matrix' : '' " >
                                                Important <br>- Urgent
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="quadrant bottom-left" :class=" priority_of_ticket.hasOwnProperty('not_imp_urgent') && priority_of_ticket.not_imp_urgent ? 'active-matrix' : '' ">
                                                Not Important <br>- Urgent
                                            </div>
                                            <div class="quadrant bottom-right" :class=" priority_of_ticket.hasOwnProperty('not_imp_not_urgent') && priority_of_ticket.not_imp_not_urgent ? 'active-matrix' : '' ">
                                                Not Important <br>- Not Urgent
                                            </div>
                                        </div>
                                    </div>
                                    <!-- v-if="priority_of_ticket" -->
                                    <el-button v-if="general_details.hasOwnProperty('eisenhower_matrix') "  slot="reference" class="text-secondary fw-500 fs-14 eisenhower-button">
                                        <i class="icon icon-eye text-white pointer vertical-align-middle-icon fs-14"></i> Eisenhower Matrix
                                    </el-button>
                                </el-popover>
                            </div>
                            <div>
                                <button  v-if="can_edit || can_close_ticket" class="edit-button-new pointer" @click="showEditBaseTemplate()">
                                    <i class="ri-pencil-line fs-22 text-white item"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="general_details.status == 'Discard' && general_details.discard_reason"
                        class="discard-description px-3 py-2 mt-2">
                        <div class="discard-label">Reason for Discard:</div>
                        <div class="discard-content" style="word-break:break-word">
                            {{ general_details.discard_reason || '-'}}</div>
                    </div>
                    <div class="box-shadow mt-2">
                        <div class="capture-image d-flex align-items-center p-2 px-4">
                            <span class="text-new-header-black fw-600 mr-3"
                                style="width: max-content;min-width: max-content;">General Details</span>
                            <div class="inner-line-hr w-100"></div>
                            <img v-if="show_hide_general_details" class="pointer capture-image-rotate"
                                @click="showHideGeneralDetails" src="/static/images/etherum-fill.svg" width="24"
                                height="24">
                            <img v-else class="pointer capture-image-rotate" @click="showHideGeneralDetails"
                                src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                        </div>
                        <div v-if="show_hide_general_details" class="px-2">
                            <div class="row mt-3">
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex" v-if="template_type == 'default'">
                                    <div class="fw-500 pr-26 text-black-shade w-250px">Assigned To :</div>
                                    <div class="fw-400 overflowing-text text-capitalize description-text-custom w-60"
                                        :title="general_details.assigned_to">
                                        <span>{{general_details.assigned_to || '-'}}</span></div>
                                </div>
                                
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex" v-if="template_type == 'multi_part'">
                                <div class="fw-500 pr-26 text-black-shade w-250px">Approver :</div>
                                <div v-if="general_details.approve_data.length > 0" class="fw-400 overflowing-text text-capitalize description-text-custom w-60">
                                    <span v-for="(approver, index) in general_details.approve_data" :key="approver.id" :title="approver.name">
                                    {{approver.name }}<span v-if="index < general_details.approve_data.length - 1">, </span>
                                    </span>
                                </div>
                                <div v-else class="fw-400 overflowing-text text-capitalize description-text-custom w-60">
                                    <span>-</span>
                                </div>
                            </div>

                                
                                <div class="col-lg-12 col-md-12 col-sm-12  d-flex mt-3 ">
                                    <div class="fw-500 pr-23 text-black-shade w-250px">Ticket Subject :</div>
                                    <div class="fw-400 overflowing-text text-capitalize description-text-custom w-60"
                                        :title="general_details.subject">
                                        <span>{{general_details.subject || '-'}}</span></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                    <div class="fw-500 pr-35 text-black-shade w-250px">Author :</div>
                                    <div class="fw-400 overflowing-text text-capitalize description-text-custom w-60"
                                        :title="general_details.created_by.name">
                                        <span>{{general_details.created_by.name || '-'}}</span></div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                    <div class="fw-500 pr-1 text-black-shade w-250px">Date and Time of Creation :</div>
                                    <div class="fw-400 d-flex align-items-center">
                                        <img src="/static/images/new-theme2024/calender_black.svg" width="22" />
                                        <span class="ml-1">
                                            {{general_details.creation_date.date.replaceAll('-','/') || '-'}}
                                        </span>
                                        <img src="/static/images/new-theme2024/time-line.svg" width="22" class="ml-3" />
                                        <span class="ml-1">
                                            {{general_details.creation_date.time || '-'}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                    <div class="fw-500 pr-36 text-black-shade w-250px">Status:</div>
                                    <div class="fw-400 overflowing-text text-capitalize description-text-custom w-60">
                                        <span>{{general_details.status|| '-'}}</span>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3">
                                    <div class="fw-500 text-black-shade w-250px">Template Name:</div>
                                    <div class="fw-400 text-capitalize description-text-custom w-60">
                                        <span>{{general_details.ticket_template.name|| '-'}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-122 col-sm-1 d-flex mt-3">
                                    <div class="fw-500 pr-22 text-black-shade w-250px">Template Type:</div>
                                    <div class="fw-400 description-content w-60 ">
                                        <span v-if="general_details.ticket_template.template_type"
                                            class="text-capitalize"
                                            v-html="general_details.ticket_template.template_type.replace(/_/g, ' ')"></span>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 d-flex mt-3 mb-2">
                                    <div class="fw-500 pr-28 text-black-shade w-250px">Description:</div>
                                    <div class="fw-400 description-content description-text-custom w-60">
                                        <pre class="fs-14 w-100 img-tag"
                                            style="overflow: hidden;word-break: break-all;white-space: normal;"
                                            v-if="general_details.description"
                                            v-html="general_details.description"></pre>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5 mb-3 box-shadow">
                    <div class="capture-image d-flex align-items-center p-2 px-4">
                        <span class="text-new-header-black mr-3"
                            style="width: max-content;min-width: max-content;">Ticket Details</span>
                        <div class="inner-line-hr w-100"></div>
                        <img v-if="show_hide_ticket_details" class="pointer capture-image-rotate"
                            @click="showHideTicketDetails" src="/static/images/etherum-fill.svg" width="24" height="24">
                        <img v-else class="pointer capture-image-rotate" @click="showHideTicketDetails"
                            src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                    </div>
                    <div v-if="show_hide_ticket_details">
                        <div v-if="template_type == 'multi_part'">
                            <div class="details-checks" v-for="(part, part_index) in overall_templates"
                                :key="part_index">
                                <div class="infoHeader">
                                    <!-- <div class="descriptionheader px-2 d-flex justify-content-between "> -->
                                    <!-- <div class="description-text-header-left">
                                            <h5 class="font-weight-bold fs-18 text-black-shade whiteSpace text-capitalize">{{ part.part_name.split('').length > 1 ?  part.part_name[0].toUpperCase() +''+ part.part_name.slice(1,) : part.part_name[0].toUpperCase()}}</h5>
                                        </div> -->
                                    <!-- <div class="description-text-header-right">
                                            <span class="collapse-addon" v-if="part.show">
                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(part)" alt="" style="top: 9px !important;transition:0.5s">
                                            </span>
                                            <span class="collapse-addon" v-else>
                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(part)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                            </span>
                                        </div> -->
                                    <!-- </div> -->
                                    <div class="capture-image d-flex align-items-center p-2 px-4">
                                        <span
                                            class="font-weight-bold fs-16 text-black-shade whiteSpace text-capitalize mr-2"
                                            style="width: max-content;min-width: max-content;">{{ part.part_name.split('').length > 1 ?  part.part_name[0].toUpperCase() +''+ part.part_name.slice(1,) : part.part_name[0].toUpperCase()}}</span>
                                        <div class="inner-line-hr w-100"></div>
                                        <img v-if="show_hide_part_details" class="pointer capture-image-rotate"
                                            @click="showHidePartDetails" src="/static/images/etherum-fill.svg"
                                            width="24" height="24">
                                        <img v-else class="pointer capture-image-rotate" @click="showHidePartDetails"
                                            src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                                    </div>

                                </div>
                                <div class="row pl-5 pr-5 pb-2" v-if="show_hide_part_details">
                                    <span class="col-lg-12 col-md-12 col-sm-12 mt-2 pb-2"
                                        v-for="(dynamic_data, index) in part.part_data" :key="index">
                                        <div class="d-flex">
                                            <div class="fw-500 w-250px text-black-shade overflowing-text description-text-custom"
                                                :title="dynamic_data.name">{{dynamic_data.name}}</div>
                                                <span>: </span>
                                            <div v-if="dynamic_data.type == 'long_answer'">
                                                <div class="fw-500 overflowing-text text-capitalize  description-text-custom w-60 "
                                                    :title="dynamic_data.answer">
                                                    <span>{{dynamic_data.answer || '-'}} </span></div>
                                            </div>
                                            <div v-else-if="dynamic_data.type == 'short_answer'">
                                                <div class="fw-500  overflowing-text text-capitalize description-text-custom w-60"
                                                    :title="dynamic_data.answer">
                                                    <span>{{dynamic_data.answer || '-'}} </span></div>
                                            </div>
                                            <div v-else-if="dynamic_data.type == 'date'">
                                                <span v-if="dynamic_data.answer.length == 0">-</span>
                                                <div v-else class="fw-500  ">
                                                    <span> <img
                                                            src="/static/images/new-theme2024/calender_black.svg"
                                                            alt=""></span>
                                                    {{dynamic_data.answer}}</div>
                                            </div>
                                            <div v-else-if="dynamic_data.type == 'time'">
                                                <span v-if="dynamic_data.answer.length == 0">-</span>
                                                <div v-else class="fw-500  ">
                                                    <span> <img
                                                            src="/static/images/new-theme2024/time-line.svg"
                                                            alt=""></span>
                                                    {{dynamic_data.answer}}</div>
                                            </div>
                                            <div v-else-if="dynamic_data.type == 'radio_button'">
                                                <div class="fw-500  overflowing-text text-capitalize description-text-custom w-60"
                                                    :title="dynamic_data.answer">
                                                    <span v-if="dynamic_data.answer.length == 0">-</span>
                                                    <span v-else>{{dynamic_data.answer}}</span></div>
                                            </div>
                                            <div
                                                v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == false">
                                                <div class="fw-500  overflowing-text" :title="dynamic_data.answer">
                                                    <span class="text-capitalize">{{dynamic_data.answer || '-'}}</span>
                                                </div>
                                            </div>
                                            <div
                                                v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == true">
                                                <div class="fw-500  overflowing-text" :title="dynamic_data.answer.name">
                                                    <span
                                                        class="text-capitalize">{{dynamic_data.answer.name || '-'}}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex" v-else-if="dynamic_data.type == 'check_box'">
                                                <span v-if="dynamic_data.answer.length == 0">-</span>
                                                <div v-else class="fw-500 text-capitalize"
                                                    v-for="(data, index) in dynamic_data.answer" :key='index'>
                                                     {{data}}<span
                                                        v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span>
                                                </div>
                                            </div>
                                            <div v-else-if="dynamic_data.type == 'tag'">
                                                <div v-if="dynamic_data.answer.length == 0">-</div>
                                                <div v-else class="fw-500   text-capitalize"
                                                    v-for="(tag_name, index) in dynamic_data.answer" :key='index'>
                                                     {{tag_name.hasOwnProperty('text') ? tag_name.text : tag_name}}<span
                                                        v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span>
                                                </div>
                                            </div>
                                            <div v-else-if="dynamic_data.type == 'date_time'">
                                                <div class="fw-500  ">
                                                    <span><img src="/static/images/new-theme2024/calender_black.svg"
                                                            alt=""></span>
                                                    {{dynamic_data.answer.slice(0, 10)}}
                                                    <span class="ml-2"><img
                                                            src="/static/images/new-theme2024/time-line.svg"
                                                            alt=""></span>
                                                    {{dynamic_data.answer.slice(11, )}}
                                                </div>
                                            </div>
                                            <div v-else-if="dynamic_data.type == 'location'">
                                                <div class="fw-500  overflowing-text description-text-custom w-60"
                                                    :title="dynamic_data.answer">
                                                    <span>{{dynamic_data.answer || '-'}}</span></div>
                                            </div>
                                        </div>
                                        <div class="mt-3"
                                            v-if="dynamic_data.hasOwnProperty('add_attachments') && dynamic_data.add_attachments">
                                            <div v-if="dynamic_data.hasOwnProperty('attachments')">
                                                <div v-if="dynamic_data.attachments.length == 0">
                                                    <div class="fw-500  mt-3">Attachment</div>
                                                    <div class="fw-500  mt-2">No Attachment Added</div>
                                                </div>
                                                <div v-else class="mt-3 d-flex ">
                                                    <span class="fw-500 mt-3 w-250px ">Attachment</span>
                                                    <div v-for="(attachment, att_index) in dynamic_data.attachments"
                                                        :key="att_index">
                                                        <div class="d-flex flex-wrap">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center w-50 my-2">
                                                                <div class="d-flex justify-content-between"
                                                                    style="width: 100%;"
                                                                    v-if="attachment.hasOwnProperty('url')">
                                                                    <div class="d-flex">
                                                                        <span>
                                                                            <img src="/static/images/storage.svg"
                                                                                width="20">
                                                                            <!-- <img class="att-img pointer" v-if="attachment.url.endsWith('.pdf')"
                                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.zip') || attachment.url.endsWith('.ZIP')" 
                                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ppt')" 
                                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.pptx')" 
                                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.csv') || attachment.url.endsWith('.CSV')" 
                                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ODS') || attachment.url.endsWith('.ods')" 
                                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.svg')"
                                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.avi') || attachment.name.endsWith('.flv') || attachment.name.endsWith('.mpg') || attachment.name.endsWith('.mpeg') || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.wav') || attachment.name.endsWith('.wmv') || attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')"
                                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                                                            <img class="att-img pointer" v-else :src="attachment.url" alt="">
                                                                            <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                                                        </span>
                                                                        <div class="fw-500 d-inline-block text-truncate overflowing-text attachment_name text-capitalize pl-3"
                                                                            :title="attachment.name">{{attachment.name}}
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <!--  v-if="attachments.hasOwnProperty('url')"<a class="pointer" :href="attachments.url" download style="text-decoration: none;"> -->
                                                                        <!-- <i class="icon icon-download"></i> -->
                                                                        <!-- <i class="icon icon-eye fs-20 pointer" @click="previewImage(attachments)"></i> -->
                                                                        <img src="/static/images/new-theme2024/eye-line.svg"
                                                                            width="20" class="mr-2 pointer"
                                                                            @click="previewImage(attachment)">
                                                                        <!-- </a> -->
                                                                    </div>
                                                                </div>
                                                                <div v-else>
                                                                    -
                                                                </div>
                                                                <!-- <div v-if="attachment.hasOwnProperty('url')">
                                                                    <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                                        <i class="icon icon-download"></i>
                                                                    </a>
                                                                </div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div class="mt-5 mb-3 " v-if="part.attach_files.length > 0 && part.show">
                                    <div class="infoHeader">
                                        <div class="descriptionheader">
                                            <!-- <div class="description-text-header-left">
                                                <h5 class=" text-black-shade fw-500 fs-14 whiteSpace">Attachments
                                                </h5>
                                            </div> -->
                                            <div class="description-text-header-right"></div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-wrap">
                                        <div class="d-flex justify-content-between align-items-center px-3  w-50 my-2"
                                            v-for="attachments in part.attach_files" :key="attachments.url">
                                            <div class="d-flex justify-content-between" style="width: 100%;"
                                                v-if="attachments.hasOwnProperty('url')">
                                                <div class="d-flex">
                                                    <span>
                                                        <img src="/static/images/storage.svg" width="20">
                                                        <!-- <img class="att-img pointer" v-if="attachments.url.endsWith('.pdf')"
                                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.zip') || attachments.url.endsWith('.ZIP')" 
                                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ppt')" 
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.pptx')" 
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.csv') || attachments.url.endsWith('.CSV')" 
                                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ODS') || attachments.url.endsWith('.ods')" 
                                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.svg')"
                                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                        <img class="att-img pointer" v-else-if="attachments.url.endsWith('.avi') || attachments.name.endsWith('.flv') || attachments.name.endsWith('.mpg') || attachments.name.endsWith('.mpeg') || attachments.name.endsWith('.mp4') || attachments.name.endsWith('.wav') || attachments.name.endsWith('.wmv') || attachments.name.endsWith('.MOV') || attachments.name.endsWith('.mov')"
                                                            src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                        <img class="att-img pointer" v-else :src="attachments.url" alt="">
                                                        <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                                    </span>
                                                    <div class="fw-500 pl-3 d-inline-block overflowing-text attachment_name text-capitalize text-truncate"
                                                        :title="attachments.name">{{attachments.name}}</div>
                                                </div>
                                                <div>
                                                    <!--  v-if="attachments.hasOwnProperty('url')"<a class="pointer" :href="attachments.url" download style="text-decoration: none;"> -->
                                                    <!-- <i class="icon icon-download"></i> -->
                                                    <!-- <i class="icon icon-eye fs-20 pointer" @click="previewImage(attachments)"></i> -->
                                                    <img src="/static/images/new-theme2024/eye-line.svg" width="20"
                                                        class="mr-2 pointer" @click="previewImage(attachments)">
                                                    <!-- </a> -->
                                                </div>
                                            </div>
                                            <div v-else>
                                                -
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="details-checks bg-lightgrey " v-for="(part, part_index) in remaining_templates"
                                :key="part_index">
                                <div class="infoHeader">
                                    <div class="descriptionheader px-2 ">
                                        <div class="description-text-header-left ">
                                            <h5
                                                class="font-weight-bold fs-15 text-black-shade whiteSpace text-capitalize">
                                                {{ part.part_name.split('').length > 1 ?  part.part_name[0].toUpperCase() +''+ part.part_name.slice(1,) : part.part_name[0].toUpperCase()}}
                                            </h5>
                                        </div>
                                        <!-- <div class="inner-line-hr"></div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-3 pl-5 pr-5 pb-2" v-if="template_type == 'default'">
                            <span class="col-lg-12 col-md-12 col-sm-12 mt-2"
                                v-for="(dynamic_data, index) in dynamic_template_data" :key="index">
                                <div class="d-flex mt-2">
                                    <div class="fw-500  text-black-shade w-250px overflowing-text "
                                        :title="dynamic_data.name">{{dynamic_data.name}} :</div>
                                    <div v-if="dynamic_data.type == 'long_answer'">
                                        <div class="text-black w-250px overflowing-text text-capitalize "
                                            :title="dynamic_data.answer">
                                            <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'short_answer'">
                                        <div class="text-black w-250px overflowing-text text-capitalize "
                                            :title="dynamic_data.answer">
                                            <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'date'">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="text-black ">
                                            <span><img src="/static/images/new-theme2024/calender_black.svg"
                                                    alt=""></span>
                                            {{dynamic_data.answer}}</div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'time'">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="text-black ml-2 ">
                                            <span><img src="/static/images/new-theme2024/time-line.svg" alt=""></span>
                                            {{dynamic_data.answer}}</div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'radio_button'">
                                        <div class="text-black w-250px overflowing-text text-capitalize "
                                            :title="dynamic_data.answer">
                                            <span v-if="dynamic_data.answer.length == 0">-</span>
                                            <span class="text-capitalize" v-else>{{dynamic_data.answer}}</span></div>
                                    </div>
                                    <div
                                        v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == false">
                                        <div class="text-black w-250px overflowing-text " :title="dynamic_data.answer">
                                            <span class="text-capitalize">{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div
                                        v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == true">
                                        <div class="text-black w-250px overflowing-text "
                                            :title="dynamic_data.answer.name">
                                            <span class="text-capitalize">{{dynamic_data.answer.name || '-'}}</span>
                                        </div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'check_box'">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="text-black text-capitalize "
                                            v-for="(data, index) in dynamic_data.answer" :key='index'>{{data}}<span
                                                v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span>
                                        </div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'tag'">
                                        <div v-if="dynamic_data.answer.length == 0">-</div>
                                        <div v-else class="text-black text-captitalize "
                                            v-for="(tag_name, index) in dynamic_data.answer" :key='index'>
                                            {{tag_name}}<span
                                                v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span>
                                        </div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'date_time'">
                                        <div class="text-black">
                                            <span><img src="/static/images/new-theme2024/calender_black.svg" alt=""
                                                    width="22"></span>
                                            {{dynamic_data.answer.slice(0, 10)}}
                                            <span class="ml-2"><img src="/static/images/new-theme2024/time-line.svg"
                                                    alt="" width="22"></span>
                                            {{dynamic_data.answer.slice(11, )}}
                                        </div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'location'">
                                        <div class="text-black w-250px overflowing-text " :title="dynamic_data.answer">
                                            <span class="text-capitalize">{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                </div>
                                <div class="mt-3"
                                    v-if="dynamic_data.hasOwnProperty('add_attachments') && dynamic_data.add_attachments">
                                    <div v-if="dynamic_data.hasOwnProperty('attachments')">
                                        <div v-if="dynamic_data.attachments.length == 0" class="d-flex">
                                            <div class="fw-500 mt-3 w-250px">Attachment:</div>
                                            <div class="500 fw-500 mt-2">No Attachment Added</div>
                                        </div>
                                        <div v-else class="mt-3">
                                            <span class="fw-500">Attachment:</span>
                                            <div class="d-flex flex-wrap">
                                                <div class="d-flex justify-content-between align-items-center px-3 w-50"
                                                    v-for="attachments in dynamic_data.attachments"
                                                    :key="attachments.url">
                                                    <div class="d-flex align-items-center"
                                                        v-if="attachments.hasOwnProperty('url')">
                                                        <span class="mr-3 mt-2">
                                                            <img src="/static/images/storage.svg" width="20">
                                                            <!-- <img class="att-img pointer" v-if="attachments.url.endsWith('.pdf')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.zip') || attachments.url.endsWith('.ZIP')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ppt')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.pptx')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.csv') || attachments.url.endsWith('.CSV')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ODS') || attachments.url.endsWith('.ods')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.svg')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                            <img class="att-img pointer" v-else-if="attachments.url.endsWith('.avi') || attachments.name.endsWith('.flv') || attachments.name.endsWith('.mpg') || attachments.name.endsWith('.mpeg') || attachments.name.endsWith('.mp4') || attachments.name.endsWith('.wav') || attachments.name.endsWith('.wmv') || attachments.name.endsWith('.MOV') || attachments.name.endsWith('.mov')"
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                            <img class="att-img pointer" v-else :src="attachments.url" alt="">
                                                            <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                                        </span>
                                                        <div class="d-inline-block overflowing-text attachment_name text-capitalize"
                                                            :title="attachments.name">{{attachments.name}}</div>
                                                        <div>
                                                            <!-- <a class="pointer" v-if="attachments.hasOwnProperty('url')" :href="attachments.url" download style="text-decoration: none;"> -->
                                                            <!-- <i class="icon icon-download"></i> -->
                                                            <!-- <i class="icon icon-eye fs-16 pointer" @click="previewImage(attachments)"></i> -->
                                                            <img src="/static/images/new-theme2024/eye-line.svg"
                                                                width="20" class="mr-2 pointer"
                                                                @click="previewImage(attachments)">
                                                            <!-- </a> -->
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        -
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mt-5 mb-3 box-shadow" v-if="template_type == 'default'">
                    <div class="capture-image d-flex align-items-center p-2 px-4">
                        <span class="text-new-header-black fw-600 mr-3"
                            style="width: max-content;min-width: max-content;">Attachments</span>
                        <div class="inner-line-hr w-100"></div>
                        <img v-if="show_hide_attachment_details" class="pointer capture-image-rotate"
                            @click="showHideAttachmentDetails" src="/static/images/etherum-fill.svg" width="24"
                            height="24">
                        <img v-else class="pointer capture-image-rotate" @click="showHideAttachmentDetails"
                            src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                    </div>
                    <div v-if="show_hide_attachment_details" class="px-2">
                        <div v-if="general_details.attach_files.length == 0" class="d-flex">
                            <div class="fw-500 fs-15px w-250px ">Attachment:</div>
                            <div class="fw-500 fs-15px ">No Attachment Added</div>
                        </div>
                        <div v-else class="mt-3 mb-3">
                            <!-- <span class="fw-500 fs-15px">Attachment</span> -->
                            <div class="d-flex flex-wrap">
                                <div class="d-flex justify-content-between align-items-center px-3 w-50"
                                    v-for="attachments in general_details.attach_files" :key="attachments.url">
                                    <div class="d-flex align-items-center" v-if="attachments.hasOwnProperty('url')">
                                        <span class=" view-img-container">
                                            <img src="/static/images/storage.svg" width="20" class="mr-2">
                                            <!-- <img class="att-img pointer" v-if="attachments.url.endsWith('.pdf')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.zip') || attachments.url.endsWith('.ZIP')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ppt')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.pptx')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.csv') || attachments.url.endsWith('.CSV')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ODS') || attachments.url.endsWith('.ods')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.avi') || attachments.name.endsWith('.flv') || attachments.name.endsWith('.mpg') || attachments.name.endsWith('.mpeg') || attachments.name.endsWith('.mp4') || attachments.name.endsWith('.wav') || attachments.name.endsWith('.wmv') || attachments.name.endsWith('.MOV') || attachments.name.endsWith('.mov')"
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                <img class="att-img pointer" v-else :src="attachments.url" alt="">
                                                <i class="icon icon-eye text-secondary pointer fa-5x"></i> -->
                                        </span>
                                        <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize"
                                            :title="attachments.name">{{attachments.name}}</div>
                                        <div>
                                            <!--  v-if="attachments.hasOwnProperty('url')"<a class="pointer" :href="attachments.url" download style="text-decoration: none;"> -->
                                            <!-- <i class="icon icon-download"></i> -->
                                            <!-- <i class="icon icon-eye fs-16 pointer" ></i> -->
                                            <img src="/static/images/new-theme2024/eye-line.svg" width="20"
                                                class="mr-2 pointer" @click="previewImage(attachments)">
                                            <!-- </a> -->
                                        </div>
                                    </div>
                                    <div v-else>
                                        -
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center my-8"
                    v-if="general_details.status == 'Closed' && general_details.ticket_template.template_type != 'multi_part'">
                    <button style="text-transform: capitalize;" disabled class="btn btn-success text-white btn-width"
                        @click="generateNewReport">
                        Generate Report
                    </button>
                </div>
            </div>
        </div>
        <change-status @updateStatus="updateStatus()" :template_type="general_details.ticket_template.template_type"
            @cancelStatus="cancelStatus" v-if="showChange" modal_name="status-change" :ticket_id="ticket_id"
            :customer_name="customer_name" :status="newStatus" :closed_ticket="closed_ticket"></change-status>
        <edit-base-template modal_name="edit-base-template" v-if="editBase" @hideEditBase="hideEditBase"
            @saveEditBase="getDetails()"></edit-base-template>
        <edit-software-bug-template modal_name="edit-software-bug-modal" v-if="editSBR" :template_id="template_id"
            @hideSBR="hideSBR" @saveEditSBR="getDetails()"></edit-software-bug-template>
        <ticket-access modal_name="ticket-access" :reasonTicketAccess="reasonTicketAccess"></ticket-access>
        <generate-report modal_name="generate-report" v-if="show_generate_report" :showDetails="showDetails"
            @hideGenerateReport="hideGenerateReport"></generate-report>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import ticket from '../mixins/ticket.js';
    import convert from '../mixins/convert.js';
    import {
        EventBus
    } from '../eventBus/nav-bar-event.js';
    // import VueTagsInput from '@johmun/vue-tags-input'
    import {
        HalfCircleSpinner
    } from 'epic-spinners';
    const ChangeStatus = () => import("./ChangeStatus");
    const EditBaseTemplate = () => import("./EditBaseTemplate");
    const TicketAccess = () => import("./AccessTicket");
    const EditSoftwareBugTemplate = () => import("./EditSoftwareBugTemplate");
    const GenerateReport = () => import("./GenerateReport");
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import setting from '../mixins/setting.js';
    export default {
        props: ['showDetails', 'is_ticket_not_found', 'watch_status', 'list_loader', 'pagination'],
        mixins: [ticket, convert, setting],
        components: {
            ChangeStatus,
            EditBaseTemplate,
            HalfCircleSpinner,
            SweetModal,
            TicketAccess,
            EditSoftwareBugTemplate,
            GenerateReport
            // VueTagsInput
        },
        data() {
            return {
                ajaxCallinprogress: false,
                show_generate_report: false,
                success_msg: '',
                warning_msg: '',
                general_details: {
                    created_by: {
                        name: ""
                    }
                },
                template_data: '',
                get_template: null,
                dynamic_template_data: [],
                template_data_SBR: '',
                visible: false,
                attachments: [],
                generic_attachments: [],
                image_attachments: [],
                audio_video_attachments: [],
                showChange: false,
                newStatus: '',
                customer_id: '',
                editBase: false,
                aggregate_costing: '',
                template_id: '',
                editSBR: false,
                reasonTicketAccess: '',
                product_id: '',
                isSBR: false,
                tags: {},
                dialogImageUrl: '',
                dialogVisible: false,
                addSP: false,
                customer_name: '',
                preview_visible: false,
                preview_file: {},
                preview_acc_id: '',
                show_priority: false,
                is_software_bug_template: '',
                template_name: '',
                overall_templates: [],
                remaining_templates: [],
                can_edit: false,
                can_change_status: true,
                can_close_ticket: false,
                is_ticket_details_not_found: false,
                check_if_approval_required: false,
                show_hide_general_details: true,
                show_hide_ticket_details: true,
                show_hide_attachment_details: true,
                show_hide_part_details: true,
                priority_of_ticket:{},



                // block_details_api: true
            }
        },
        methods: {
            showHideTicketDetails() {
                this.show_hide_ticket_details = !this.show_hide_ticket_details
            },
            showHideGeneralDetails() {
                this.show_hide_general_details = !this.show_hide_general_details
            },
            showHideAttachmentDetails() {
                this.show_hide_attachment_details = !this.show_hide_attachment_details
            },
            showHidePartDetails() {
                this.show_hide_part_details = !this.show_hide_part_details
            },
            ToggleParts(part) {
                if (part.show) {
                    part.show = false
                } else {
                    part.show = true
                }
                this.$forceUpdate()
            },
            previewImage(file) {
                this.$emit('previewImage', file)
                EventBus.$emit('ZindexChangeStart')
            },
            generateNewReport() {
                this.show_generate_report = true;
                setTimeout(() => {
                    this.$modal.show('generate-report');
                }, 500);
            },
            hideGenerateReport() {
                this.show_generate_report = false;
            },
            hideSBR() {
                this.editSBR = false
            },
            cancelStatus() {
                this.showChange = false
            },
            updateStatus() {
                this.showChange = false;
                this.getDetails();
            },
            showAllStatus() {
                this.newStatus = this.general_details.status
                this.showChange = true
                setTimeout(() => {
                    this.$modal.show('status-change');
                }, 500);
            },
            hideEditBase() {
                this.editBase = false
            },
            showEditBaseTemplate() {
                let page_data = {
                    pagination: this.pagination,
                    ticket_details: this.showDetails
                }
                localStorage.setItem('pagination_backup', JSON.stringify(page_data))
                if (this.$route.query.hasOwnProperty('view_ticket')) {
                    let params = {
                        view_ticket: this.$route.query.view_ticket
                    }
                    localStorage.setItem('storeQueryTicketType', JSON.stringify(params))
                }
                this.$router.push({
                    path: "/ticketdetails/edit/" + this.showDetails.ticket_id
                });
            },
            async showEditSoftwareBugModal() {
                try {
                    let params = {
                        ticket_id: this.showDetails.ticket_id
                    }
                    let res = await this.setEditDetails(params)
                    this.editSBR = true
                    this.template_id = this.template_data_SBR.template_id
                    setTimeout(() => {
                        this.$modal.show('edit-software-bug-modal');
                    }, 500);
                } catch (reason) {
                    this.reasonTicketAccess = reason
                    setTimeout(() => {
                        this.$modal.show('ticket-access');
                    }, 500);
                }
            },
            distinctAttachments() {
                this.generic_attachments = []
                this.image_attachments = []
                this.audio_video_attachments = []
                if (this.attachments.hasOwnProperty('url')) {
                    this.attachments.forEach((el, index) => {
                        if (el.url.endsWith('.doc') || el.url.endsWith('.docx') || el.url.endsWith('.htm') || el
                            .url.endsWith('.html') || el.url.endsWith('.pdf') || el.url.endsWith('.ppt') || el
                            .url.endsWith('.pptx') || el.url.endsWith('.txt') || el.url.endsWith('.xls') || el
                            .url.endsWith('.xlsx')) {
                            this.generic_attachments.push(el)
                        } else if (el.url.endsWith('.png') || el.url.endsWith('.PNG') || el.url.endsWith(
                            '.jpg') || el.url.endsWith('.JPG') || el.url.endsWith('.svg') || el.url.endsWith(
                                '.bmp') || el.url.endsWith('.BMP') || el.url.endsWith('.jpeg') || el.url
                            .endsWith('.JPEG') || el.url.endsWith('.gif') || el.url.endsWith('.tiff')) {
                            this.image_attachments.push(el)
                        } else if (el.url.endsWith('.avi') || el.url.endsWith('.flv') || el.url.endsWith(
                            '.mpg') || el.url.endsWith('.mpeg') || el.url.endsWith('.mp3') || el.url.endsWith(
                                '.mp4') || el.url.endsWith('.wav') || el.url.endsWith('.wmv')) {
                            this.audio_video_attachments.push(el)
                        }
                    })
                }
            },
            async getDetails() {
                try {
                    this.overall_templates = []
                    this.ajaxCallinprogress = true;
                    let params = {
                        ticket_id: this.showDetails.ticket_id
                    }
                    let res = await this.getTicketById(params)
                    // this.block_details_api = false
                    // this.is_ticket_details_not_found = false;
                    this.ajaxCallinprogress = false;
                    this.general_details = res.response.general_details
                    if(this.general_details.hasOwnProperty('eisenhower_matrix') && Object.keys(this.general_details.eisenhower_matrix).length >0 ){
                        this.priority_of_ticket = this.general_details.eisenhower_matrix
                    } 
                    else{
                        this.priority_of_ticket = {}
                    }
                    this.template_name = this.general_details.ticket_template.name
                    this.template_type = this.general_details.ticket_template.template_type
                    this.can_edit = res.response.can_edit
                    this.showChange = false
                    if (this.template_type == 'default') {
                        this.dynamic_template_data = res.response.template_data[this.template_name]
                        this.template_data = res.response.template_data;
                        this.attachments = this.general_details.attach_files || []
                        this.dynamic_template_data.forEach((el) => {
                            if (el.add_attachments && !el.hasOwnProperty('attachments')) {
                                el.attachments = []
                            }
                        })
                    } else {
                        if (res.response.hasOwnProperty('template_data')) {
                            res.response.template_data.forEach((e) => {
                                e.show = true
                                e.part_data.forEach((pd) => {
                                    if (pd.add_attachments && !pd.hasOwnProperty('attachments')) {
                                        pd.attachments = []
                                    }
                                })
                                if (e.part_data.length > 0) this.overall_templates.push(e);
                            })
                        } else {
                            this.check_if_approval_required = true
                            this.can_close_ticket = res.response.can_save
                            res.response.approved_part_details.forEach((e) => {
                                console.log(e)
                                e.show = true
                                e.part_data.forEach((pd) => {
                                    if (pd.add_attachments && !pd.hasOwnProperty('attachments')) {
                                        pd.attachments = []
                                    }
                                })
                                if (e.part_data.length > 0) this.overall_templates.push(e);
                            })
                            res.response.pending_details.forEach((e) => {
                                console.log(e)
                                e.show = true
                                e.part_data.forEach((pd) => {
                                    if (pd.add_attachments && !pd.hasOwnProperty('attachments')) {
                                        pd.attachments = []
                                    }
                                })
                                if (e.part_data.length > 0) this.overall_templates.push(e);
                            })
                            this.remaining_templates = res.response.remaining_parts
                            if (res.response.pending_details.length == 0) {
                                this.can_change_status = false
                            }
                        }
                    }
                    this.$emit('passGeneralDetails', res.response.general_details)
                    // Dynamic template data
                    this.customer_name = this.general_details.customer_name
                    this.distinctAttachments()
                } catch (reason) {
                    this.ajaxCallinprogress = false;
                }
            },
            closeTicket() {
                this.$router.push({
                    path: `/ticketdetails/edit/${this.$route.params.id}`,
                    query: {
                        type: 'normal_ticket'
                    }
                })
            },
            capitalize(string) {
                return string[0].toUpperCase() + string.substring(1);
            },
            async getIsShowPriority() {
                let param = {
                    settings_type: ['display_ticket_priorities']
                }
                let data = await this.getAllJobTypes(param);
                this.show_priority = data.response.display_ticket_priorities.display_ticket_priorities;
            },
        },
        created() {},
        async mounted() {
            EventBus.$on('ticketFromFirebaseNotify', (data) => {
                if (data.active_tab == 'ticket_details') {
                    if (this.showDetails.ticket_id) {
                        this.getDetails();
                    }
                }
            })
            if (this.showDetails.ticket_id) {
                this.getDetails();
            }
        },
        destroyed() {
            EventBus.$off('viewDetails')
        },
        watch: {
            "$route.params": function (params) {
                if (params.id) {
                    this.getDetails();
                }
            },
            "showDetails": function (params) {
                if (params.ticket_id) {
                    this.getDetails();
                }
                this.show_hide_ticket_details = true
                this.show_hide_general_details = true
            },
            "watch_status": function(params){
                this.general_details.status = params
            }
        },
        destroyed() {},
        computed: {
            loggedInUser() {
                return this.$store.state.store.loggedInUser
            },
            showDept() {
                return this.$store.state.store.getGeneralSettings.display_department_section_in_base_template
                    .display_department_section_in_base_template
            },
            getGeneralSettings() {
                return this.$store.state.store.getGeneralSettings
            },
            product_naming_convention() {
                if (this.getGeneralSettings && this.getGeneralSettings.naming_convention_of_products) {
                    return this.capitalize(this.getGeneralSettings.naming_convention_of_products
                        .naming_convention_of_products)
                } else {
                    return ''
                }
            },
            closed_ticket() {
                return {
                    ticket_number: this.general_details.ticket_number,
                    subject: this.general_details.subject,
                    author_name: this.general_details.created_by.name,
                    assigned_to: this.general_details.assigned_to,
                    description: this.general_details.description,
                    ticket_id: this.showDetails.ticket_id
                }
            }
        }
    }
</script>
<style scoped>
.w-60{
     width:400px !important;
}
    .btn-width {
        width: 150px !important;
    }

    .productBox {
        border: 1px solid #005dae;
        border-radius: 8px;
        padding: 10px 20px;
        margin: 15px 0;
        background: #FFF;
    }

    .warranty {
        padding: 5px 10px;
        border-radius: 10px;
        background-color: #2dc96f;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
    }

    .out_warranty {
        padding: 5px 10px;
        border-radius: 10px;
        background-color: #f86c65;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
    }

    .serviceBox {
        border: 1px solid #005dae;
        border-radius: 8px;
        padding: 10px 20px;
    }

    .borderBottomBlue {
        border: 0.5px solid #005dae;
    }

    .box-blue {
        background-color: #00448b;
        border-radius: 18px;
        padding: 10px 20px;
    }

    .box-title {
        background-color: #ffffff;
        border-top-left-radius: 18px;
        border-top-right-radius: 18px;
    }

    .box-inside {
        background-color: #ebf4fe;
        border-radius: 18px;
    }

    .rating {
        background-color: #ffffff;
        border-radius: 5px;
        text-align: center;
    }

    .signaturebg {
        background-color: #ffffff;
        width: 80%;
        border-radius: 5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        border: solid 0.3px #f5a623;
    }

    .ticket_subject {
        /* width: 250px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; */
        word-break: break-all;
    }

    .table-hover-none tbody tr:hover {
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        background-color: #fff !important;
    }

    .product-bg {
        background-color: #ffffff;
        border: 1px solid #707070;
        padding: 5px;
        border-radius: 4px;
    }

    .product-bg-list {
        border-bottom: 1px solid #005dae;
    }

    .tech-file-bg {
        background-color: #f7f8fa;
        border-radius: 4px;
        padding: 10px;
        height: 225px;
    }

    .rating-counts {
        background-color: #ffffff;
        border: 1px solid #ecf5ff;
        border-radius: 5px;
        min-height: 150px;
        padding: 5px;
        margin-top: 10px;
    }

    .box-blue-header {
        border-radius: 3px;
    }

    .bottomBorder {
        border-bottom: 1px solid #005dae;
        padding-bottom: 5px;
    }

    .topBorder {
        border-top: 1px solid #005dae;
        padding-bottom: 5px;
    }

    .box-with-blue-border {
        border: 15px solid #005dae;
        border-left-width: 10px;
        border-right-width: 10px;
    }

    .box-blue-header-parent {
        background: #005dae;
        position: relative;
        top: -1px;
        margin-left: -1px;
    }

    .bottom-border {
        border-bottom: 1px solid #cce3fc;
    }

    ._images {
        margin: 5px;
        padding: 5px;
        border-radius: 2.5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.2);
        background-color: #f6f8ff;
        /* width: 177px !important;
    height: 100px !important; */
        /* width: 135px !important; */
        max-width: 30%;
        min-width: 100px;
        height: 90px !important;
        display: flex;
        flex-direction: column;
    }

    /* ._images>img{
    height: 90px;
} */
    .att-background {
        background-color: #F1F3F4;
        margin: 8px;
        border-radius: 8px;
    }

    .att-img {
        height: 80px;
        /* max-width: 30% */
    }

    .attachment_name {
        max-width:280px;
        min-width:185px;
        width: 385px;
    }

    .w-50 {
        width: 50%
    }

    .description-content {
        /* word-break: break-all;
    white-space: pre-wrap;
    line-break: anywhere; */
        text-align: justify;
    }

    .details-checks {
        border: 1px solid #0f5dae;
        border-radius: 5px !important;
        padding: 10px;
        margin-top: 10px;
        margin: 10px;
    }

    .infoHeader>.descriptionheader .description-text-header-right img {
        width: 23px;
    }

    .btn-danger {
        background-color: #f87a74;
    }

    .btn-success {
        background-color: #41ae5d;
    }

    .btn-success,
    .btn-danger {
        width: 150px !important;
        text-transform: capitalize;
        font-weight: 500;
    }

    .bg-lightgrey {
        background-color: #f1f1f1 !important;
    }

    .w-20 {
        width: 20%
    }

    /* @media screen and (max-width: 1250px) {
    .attachment_name{
        width: 265px;
    }
}
@media (min-width:768px) and (max-width: 1070px){
    .attachment_name{
        width: 150px;
    }
} */
    @media screen and (max-width: 768px) {
        .col-flex-sm {
            flex-direction: column;
        }

        .w-sm-100 {
            width: 100% !important;
        }
    }

    .edit-button {
        background-color: #fff;
        height: 32px !important;
        width: 40px;
        line-height: 32px !important;
        border-radius: 4px;
    }

    .capture-image-rotate {
        transform: rotate(180deg);
        transition: all 0.3s;
    }

    .active-capture-image-rotate {
        transform: unset;
    }

    .inner-line-hr {
        border: 0;
        width: 100%;
        border-top: 2px solid #bed1f8;
    }

    .discard-description {
        background-color: #eedfdf;
    }

    .discard-label {
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.18px;
        text-align: left;
        color: #ab514c;
        margin-bottom: 10px;
    }

    .discard-content::first-letter {
        text-transform: uppercase
    }

    .view-img-container {
        position: relative;
    }

    .view-img-container i {
        position: absolute;
        top: 45%;
        left: 45%;
        transform: translate(-45%, -45%);
        display: none;
    }

    .view-img-container:hover img {
        opacity: 0.2;
    }

    .view-img-container:hover i {
        display: block;
        z-index: 500;
    }

    .box-shadow {
        padding: 8px 5.5px 8px 9.5px;
        object-fit: contain;
        border-radius: 1px;
        box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.33);
        background-color: #fff;
    }

    .file-bg {
        background-color: #f0f3f5;
        padding: 5px;
        border-radius: 2px;
    }
    .active-matrix{
        color: #fff;
        background-color: #2bb883;
    }
    .eisenhower-button {
            width: 165px;
            font-size: 14px !important;
            height: 35px;
            padding: 0 10px !important;
            border-radius: 6px !important;
            background-color: #00448b !important;
            color: #fff !important;
            font-weight: 500;
        }
        .quadrant{
            width:130px;
            height: 80px;
            display: flex;
            align-items: center;
            padding-left:20px
        }
        .quadrant.top-left{
            border-right: .5px solid #242629;
            border-bottom: .5px solid #242629;
        }
        .quadrant.bottom-left{
            border-right: .5px solid #242629;
            border-top: .5px solid #242629;
        }
        .quadrant.top-right{
            border-left: .5px solid #242629;
            border-bottom: .5px solid #242629;
        }
        .quadrant.bottom-right{
            border-left: .5px solid #242629;
            border-top: .5px solid #242629;
        }
        .header-text {
            color: #242629;
            font-weight: 600;
            text-decoration: underline;
        }


</style>